<template>
  <div class="ranking-card">
    <div class="ranking-header">
      <div class="rank-number" :class="'rank-' + rank">#{{ rank }}</div>
      <div class="player-info">
        <span class="player-uuid">{{ user.uuid }}</span>
        <span class="bet-count">已投注 {{ user.bet_count }} 場</span>
      </div>
      <button v-if="!user.is_me" class="btn-follow" @click="toggleFollow" :class="{ following: localIsFollowed }">
        <svg viewBox="0 0 24 24" :fill="localIsFollowed ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>
    </div>
    <div class="ranking-stats">
      <div class="stat-item">
        <span class="stat-label">當月總輸贏</span>
        <span class="stat-value" :class="user.this_month_net > 0 ? 'text-win' : (user.this_month_net < 0 ? 'text-lose' : 'text-void')">
          {{ user.this_month_net >= 0 ? '+' : '' }}{{ fmt(user.this_month_net) }}
        </span>
      </div>
      <div class="stat-item">
        <span class="stat-label">上月總輸贏</span>
        <span class="stat-value" :class="user.last_month_net > 0 ? 'text-win' : (user.last_month_net < 0 ? 'text-lose' : 'text-void')">
          {{ user.last_month_net >= 0 ? '+' : '' }}{{ fmt(user.last_month_net) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RankingCard',
  props: {
    user: { type: Object, required: true },
    rank: { type: Number, required: true }
  },
  data() {
    return {
      localIsFollowed: this.user.is_followed
    }
  },
  computed: {
    ...mapState(['uuid']),
  },
  watch: {
    'user.is_followed'(val) {
      this.localIsFollowed = val
    }
  },
  methods: {
    toggleFollow() {
      const newStatus = !this.localIsFollowed
      this.localIsFollowed = newStatus
      this.$store.dispatch('toggleFollowUser', { 
        followedUserId: this.user.user_id, 
        isFollowing: !newStatus 
      }).catch(() => {
        // Revert on failure
        this.localIsFollowed = !newStatus
      })
    },
    fmt(val) {
      if (val === null || val === undefined) return '0'
      const n = Number(val)
      if (isNaN(n)) return val
      return n % 1 === 0 ? String(n) : n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
    }
  }
}
</script>

<style scoped>
.ranking-card {
  background: var(--bg-card);
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  transition: background var(--transition-fast);
}

.ranking-card:last-child {
  border-bottom: none;
}

.ranking-card:hover {
  background: var(--bg-card-hover);
}

.ranking-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.rank-number {
  font-size: 18px;
  font-weight: 800;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--bg-overlay);
  color: var(--text-muted);
  margin-right: 12px;
}

.rank-1 { background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%); color: #fff; }
.rank-2 { background: linear-gradient(135deg, #E0E0E0 0%, #9E9E9E 100%); color: #fff; }
.rank-3 { background: linear-gradient(135deg, #CD7F32 0%, #A0522D 100%); color: #fff; }

.player-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.player-uuid {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.bet-count {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

.btn-follow {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  padding: 4px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.btn-follow svg {
  width: 24px;
  height: 24px;
}

.btn-follow.following {
  color: #E53935;
}

.btn-follow:hover {
  background: var(--bg-overlay);
}

.ranking-stats {
  background: var(--bg-body);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-label {
  font-size: 12px;
  color: var(--text-muted);
}

.stat-value {
  font-size: 18px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.text-win { color: #E53935; }
.text-lose { color: #2E7D32; }
.text-void { color: #9E9E9E; }
</style>
